/*
 * Copyright (c) 2023. All rights reserved by kudiyar
 *
 */

const FallbackRoller = () => {
  return <h1>Loading...</h1>
}
export default FallbackRoller